import { create } from 'zustand';

type FormDirtyStore = {
  /**
   * フォームが編集されているかどうか
   */
  isDirty: boolean;
  /**
   * フォームの編集状態を設定
   */
  setIsDirty: (isDirty: boolean) => void;
};

/**
 * フォームの編集状態を管理するグローバルストア
 *
 * フォーム離脱時のアラート表示に使用
 */
export const useFormDirtyStore = create<FormDirtyStore>((set) => ({
  isDirty: false,
  setIsDirty: (isDirty: boolean) => set({ isDirty }),
}));
